import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Home, Music, HardHat, Scale, Smile, Dumbbell, Car, Star } from 'lucide-react';
export function SocialProofSlide() {
  const clients = [{
    icon: Heart,
    name: 'Health & Wellness'
  }, {
    icon: Home,
    name: 'Real Estate'
  }, {
    icon: Music,
    name: 'Music Academy'
  }, {
    icon: HardHat,
    name: 'Construction'
  }, {
    icon: Scale,
    name: 'Legal Services'
  }, {
    icon: Smile,
    name: 'Dental Practice'
  }, {
    icon: Dumbbell,
    name: 'Fitness Studio'
  }, {
    icon: Car,
    name: 'Auto Services'
  }];
  const courseGroupA = [{
    title: '7-Day SEO Growth',
    image: 'https://cdn.magicpatterns.com/uploads/hiroPc9PqXMVtpjsgiZExr/7_Day_SEO_Growth.jpg'
  }, {
    title: '14-Day Ads Booster',
    image: 'https://cdn.magicpatterns.com/uploads/rZXvbLc12Rf9s7w5ZpPajW/14_Day_Ads_Booster.jpg'
  }, {
    title: '21-Day AI Delegation',
    image: 'https://cdn.magicpatterns.com/uploads/rtE39ViUMJtmYYECUGLF8N/21_Day_AI_Delegation.jpg'
  }];
  const courseGroupB = [{
    title: '14-Day Local Website Leads',
    image: 'https://cdn.magicpatterns.com/uploads/1qxAqgs6chDHinFXj5VakT/14_Day_Local_Website_Leads.jpg'
  }, {
    title: '14-Day E-Com Website Leads',
    image: 'https://cdn.magicpatterns.com/uploads/b2vo9x794Y7McRuyeRQbFz/14_Day_E-Com_Website_Leads.jpg'
  }, {
    title: '14-Day Global Appointment Leads',
    image: 'https://cdn.magicpatterns.com/uploads/kxWNn7XMYbCTr7ETsj3HYL/14_Day_Global_Appointment_Website_Leads.jpg'
  }];
  const FannedGroup = ({
    courses,
    delay
  }: {
    courses: typeof courseGroupA;
    delay: number;
  }) => <div className="relative w-[280px] md:w-[360px] h-[200px] md:h-[260px] flex-shrink-0" data-id="element-537" data-mp="1l8ehi22fez6t">
      {/* Back left */}
      <motion.div initial={{
      opacity: 0,
      x: -40,
      rotate: -18
    }} whileInView={{
      opacity: 1,
      x: 0,
      rotate: -10
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7,
      delay: delay,
      ease: 'easeOut'
    }} className="absolute shadow-xl shadow-black/50 overflow-hidden rounded-xl" style={{
      zIndex: 10,
      width: '75%',
      left: '0%',
      top: '8%',
      transformOrigin: 'bottom center'
    }} data-id="element-538" data-mp="3i8izs5rgq2zu">
        <img src={courses[0].image} alt={courses[0].title} className="w-full h-auto block" data-id="element-539" data-mp="38bwghlesbjzx" />
      </motion.div>

      {/* Front center */}
      <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      y: 0,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7,
      delay: delay + 0.15,
      ease: 'easeOut'
    }} className="absolute shadow-2xl shadow-black/70 overflow-hidden rounded-xl border border-white/10" style={{
      zIndex: 30,
      width: '80%',
      left: '10%',
      top: '0%'
    }} data-id="element-540" data-mp="2fu1xgtnsy6an">
        <img src={courses[1].image} alt={courses[1].title} className="w-full h-auto block" data-id="element-541" data-mp="1a1fhy8xynqzu" />
      </motion.div>

      {/* Back right */}
      <motion.div initial={{
      opacity: 0,
      x: 40,
      rotate: 18
    }} whileInView={{
      opacity: 1,
      x: 0,
      rotate: 10
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7,
      delay: delay,
      ease: 'easeOut'
    }} className="absolute shadow-xl shadow-black/50 overflow-hidden rounded-xl" style={{
      zIndex: 10,
      width: '75%',
      right: '0%',
      top: '8%',
      transformOrigin: 'bottom center'
    }} data-id="element-542" data-mp="103rkvccvu7ei">
        <img src={courses[2].image} alt={courses[2].title} className="w-full h-auto block" data-id="element-543" data-mp="3z6arx9ozbc" />
      </motion.div>
    </div>;
  return <section id="clients" className="min-h-screen bg-dark py-24 px-4 flex flex-col justify-center" data-id="element-544" data-mp="rvy7ptt6gubd">
      <div className="max-w-7xl mx-auto w-full" data-id="element-545" data-mp="nttj59hl6nvl">
        <div className="text-center mb-16" data-id="element-546" data-mp="nv4jt0fqjfih">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-4" data-id="element-547" data-mp="iuqnugrerw0t">
            Trusted By Service-Based Businesses
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-text-muted" data-id="element-548" data-mp="2oizflm61qrx0">
            Join 200+ service-based businesses using LetLois
          </motion.p>
        </div>

        {/* Client Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20" data-id="element-549" data-mp="37bbg03d53j4i">
          {clients.map((client, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} whileHover={{
          scale: 1.05,
          borderColor: '#1a8bf6'
        }} className="flex flex-col items-center justify-center p-8 bg-dark-card border border-white/5 rounded-2xl group transition-all duration-300" data-id="element-550" data-mp="3h74z65ld6av9" data-mpi={index}>
              <client.icon size={48} className="text-text-muted mb-4 group-hover:text-primary transition-colors duration-300" data-id="element-551" data-mp="1tnc3tqpp8xa1" />
              <span className="text-text-dim font-medium group-hover:text-white transition-colors duration-300 text-center" data-id="element-552" data-mp="22osb3pl7wja1">
                {client.name}
              </span>
            </motion.div>)}
        </div>

        {/* LetLois Courses Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-24" data-id="element-553" data-mp="27gtndbidya02">
          <div className="text-center mb-12" data-id="element-554" data-mp="303tbe9qh5pog">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-555" data-mp="304uwl717fsjw">
              LetLois Courses
            </h3>
            <p className="text-xl text-text-muted max-w-2xl mx-auto" data-id="element-556" data-mp="350k1zqzwo3o4">
              Master lead generation, ads, and AI delegation with our
              step-by-step courses.
            </p>
          </div>

          {/* Two groups of fanned thumbnails side by side */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-12 md:gap-20" data-id="element-557" data-mp="2hcab4anu4pq4">
            <div className="text-center" data-id="element-558" data-mp="2m4k7a8fjmm0u">
              <FannedGroup courses={courseGroupA} delay={0.1} data-id="element-559" data-mp="28cdrwok7sj2g" />
              <p className="text-text-muted text-sm mt-6 font-medium" data-id="element-560" data-mp="28dyosku04e3h">
                Growth Series
              </p>
            </div>
            <div className="text-center" data-id="element-561" data-mp="1ye7qe82bley4">
              <FannedGroup courses={courseGroupB} delay={0.3} data-id="element-562" data-mp="1yf93sj6t6dj0" />
              <p className="text-text-muted text-sm mt-6 font-medium" data-id="element-563" data-mp="23d16m88zrk1z">
                Website Leads Series
              </p>
            </div>
          </div>
        </motion.div>

        {/* Healthy Habits Case Study */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-primary/10 to-blue-900/10 border border-primary/20 rounded-2xl p-8 md:p-12 mb-20 relative overflow-hidden" data-id="element-564" data-mp="2dvzamdfin1ns">
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-565" data-mp="1v5hleitw6o76">
            <div className="flex-1" data-id="element-566" data-mp="1q5vawh5g7m22">
              <div className="flex items-center mb-4 text-primary font-bold uppercase tracking-wider text-sm" data-id="element-567" data-mp="1q6wj8dv2xug3">
                <span className="w-2 h-2 bg-primary rounded-full mr-2" data-id="element-568" data-mp="1m2ynmd4yr1rs"></span>
                Case Study Highlight
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-569" data-mp="1c6c1zm4tc6op">
                "Healthy Habits" Clinic
              </h3>
              <p className="text-text-muted text-lg mb-4" data-id="element-570" data-mp="3ntpbenq59cn9">
                Implemented LetLois AI-SEO and Delegate plan.
              </p>
              <div className="flex items-center gap-2 text-yellow-400" data-id="element-571" data-mp="1n0u7jvgwqdp">
                <Star size={18} className="fill-yellow-400" data-id="element-572" data-mp="1nsc5rw56pli" />
                <Star size={18} className="fill-yellow-400" data-id="element-573" data-mp="5ovqg9yjkdkm" />
                <Star size={18} className="fill-yellow-400" data-id="element-574" data-mp="353pqmd1c6jpn" />
                <Star size={18} className="fill-yellow-400" data-id="element-575" data-mp="355amq73auapm" />
                <Star size={18} className="fill-yellow-400" data-id="element-576" data-mp="3a2as0fsbr9fo" />
                <span className="text-sm text-text-muted ml-2" data-id="element-577" data-mp="3a0g54vxht78y">
                  Google Reviews increased 4x
                </span>
              </div>
            </div>

            <div className="flex-1 bg-dark/50 backdrop-blur-sm p-6 rounded-xl border border-white/10 text-center" data-id="element-578" data-mp="3iwp469hk63uk">
              <p className="text-4xl md:text-5xl font-bold text-green-400 mb-2" data-id="element-579" data-mp="2mczpotvbt6zf">
                +122%
              </p>
              <p className="text-white font-medium" data-id="element-580" data-mp="663xgi0j0nmc">New Patient Appointments</p>
              <p className="text-text-dim text-sm mt-2" data-id="element-581" data-mp="687zeuev7cjz">in just 90 days</p>
            </div>
          </div>
        </motion.div>

        {/* Platform Image */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-20 relative" data-id="element-582" data-mp="f7v2dkn8sqf5">
          <img src="https://cdn.magicpatterns.com/uploads/1JfsBnqQGmhjyKxRftM1LL/Fractured_Tech_Stack.png" alt="Fractured Tech Stack" className="w-full max-w-5xl mx-auto" data-id="element-583" data-mp="3nkiuynkol622" />
        </motion.div>
      </div>
    </section>;
}